import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PaymentTerm } from '../../models'

export const PaymentTermMock = Factory.Sync.makeFactory<PaymentTerm>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words()),
  active: true,
  description: Factory.each(() => faker.random.words()),
})
